export const AfterBarkPlacedModal = (methodOptions = {}) => {
	const { hideLoading } = window.Bark;

	const state = {
		additionalDetailsModalOpen: false,
		showSuccessModal: false,
	};

	const successModal = $('#post-bark-welcome-modal');

	const bindEvents = () => {
		$('.js-modal-navigate', successModal)
			.off('click.nav')
			.on('click.nav', ({ target }) => {
				const $target = $(target);
				const { dir } = $target.data();
				const currentPage = $target.closest('.js-post-bark-modal-page');
				const pages = $('.js-post-bark-modal-page');
				const indexOneKeyed = pages.index(currentPage) + 1;

				if (dir === 'fwd') {
					if (indexOneKeyed < pages.length) {
						pages.addClass('d-none');
						currentPage.next('.js-post-bark-modal-page').removeClass('d-none');
					} else {
						$('.modal').modal('hide');
						typeof opts.callbackAfterComplete === 'function' &&
							opts.callbackAfterComplete();
					}
				} else if (dir === 'back') {
					if (indexOneKeyed - 1 !== 0) {
						pages.addClass('d-none');
						currentPage.prev('.js-post-bark-modal-page').removeClass('d-none');
					}
				}
			});

		$('.js-modal-back-to-additional', successModal)
			.off('click.backToAdditional')
			.on('click.backToAdditional', () => {
				$('.modal').modal('hide');
				$(additionalDetailsModalSelector).modal('show');
			});
	};

	/**
	 * Show the additional details modal
	 */
	const showAdditionalDetailsModal = async () => {
		window.BuyerApp.launchModule('additional-details', '__additional-details-modal', {
			hashedProjectId: methodOptions.project.id,
			currentAdditionalDetails: {
				text: methodOptions.project.attributes.project_detail || undefined,
			},
			onSubmit: () => {
				$('#additional-details-modal-with-progress').modal('hide');
			},
		});

		hideLoading();

		state.additionalDetailsModalOpen = true;
		$('#additional-details-modal-with-progress').modal('show').addClass('open');
	};

	/**
	 * Configure and then show the success modal
	 * @param {boolean} showSuccessPage
	 * @param {boolean} hadAdditionalDetails
	 */
	const configureAndShowSuccessModal = (
		showSuccessPage,
		hadAdditionalDetails = false,
	) => {
		let firstPage;
		let backBtn;

		if (!showSuccessPage) {
			$('.js-post-bark-tick-page').remove();
		}

		// no bnb section loaded so remove
		if (!$('.js-bark-placed-bnb-section').children().length) {
			$('.js-post-bark-bnb-section').remove();
		}

		if (hadAdditionalDetails) {
			$('.js-modal-back-to-additional', firstPage).removeClass('d-none');
		}

		firstPage = $('.js-post-bark-modal-page:first', successModal).removeClass('d-none');
		backBtn = $('.js-modal-navigate[data-dir="back"]', firstPage).addClass('d-none');

		if (!hadAdditionalDetails) {
			backBtn.parent().toggleClass('justify-content-between justify-content-end');
		}

		successModal.modal('show');
	};

	/**
	 * Perform whatever action is required after a Bark is placed
	 */
	const showSuccessModal = async () => {
		await useNamespace('buyer_placed_bark-additional-services-upsell-modal');

		state.showSuccessModal = true;
		if (!state.additionalDetailsModalOpen) {
			configureAndShowSuccessModal(true);
		}
	};

	bindEvents();

	return {
		showSuccessModal,
		showAdditionalDetailsModal,
	};
};

export const showAdditionalDetailsIfNeededAfterBark = (
	{ firstView, project },
	callbackAfterComplete,
) => {
	if (shouldShowAdditionalDetails(firstView, project.attributes)) {
		AfterBarkPlacedModal({ project }).showAdditionalDetailsModal();
	} else {
		typeof callbackAfterComplete === 'function' && callbackAfterComplete();
	}
};

export const shouldShowAdditionalDetails = (firstView, project) => {
	return (
		project?.additional_details_settings?.can_show &&
		!project?.project_detail &&
		!project?.additional_details_settings?.user_action
	);
};
